import { useEffect } from 'react';
import {
    gerarFuncionalidadeDeLibras,
    omitirFuncionalidadeDeLibras,
} from '@/services/libras.service';
import { PREFERENCIA_LIBRAS, subscribePreferencias } from '@/services/preferencias.service';

export default function LibrasManager() {
    useEffect(() => {
        return subscribePreferencias((preferencias) => {
            if (preferencias[PREFERENCIA_LIBRAS] === false) {
                omitirFuncionalidadeDeLibras();
            } else {
                gerarFuncionalidadeDeLibras();
            }
        });
    }, []);

    return null;
}
